/*
 * 	Easy Tooltip 1.0 - jQuery plugin
 *	written by Alen Grakalic	
 *	http://cssglobe.com/post/4380/easy-tooltip--jquery-plugin
 *
 *	Copyright (c) 2009 Alen Grakalic (http://cssglobe.com)
 *	Dual licensed under the MIT (MIT-LICENSE.txt)
 *	and GPL (GPL-LICENSE.txt) licenses.
 *
 *	Built for jQuery library
 *	http://jquery.com
 *
 */
 
(function($) {

    $.fn.easyTooltip = function(options) {

        // default configuration properties
        var defaults = {
            xOffset: 5,
            yOffset: 5,
            tooltipId: "easyTooltip",
            clickRemove: true,
            content: "",
            useElement: ""
        };

        var options = $.extend(defaults, options);
        var content;
        this.each(function() {

            var title = $(this).attr("tooltip");
            var $this = $(this);
            $(this).hover(function(e) {
                content = ($this.attr('tooltip') != null) ? $this.attr('tooltip') : title;
                content = (options.content != "") ? options.content : content;
                content = (options.useElement != "") ? $("#" + options.useElement).html() : content;
                content = $.trim(content);
                //$(this).attr("title", "");
           

                if (content != undefined && content.length > 1) {
                    if ($("#" + options.tooltipId).length == 0)
                        var popupWithShadow = "<div id='shadowContainer' ><div class='blShadow bottomShadows'>&nbsp;</div><div class='bShadow bottomShadows'>&nbsp;</div>" +
                                  "<div class='brShadow bottomShadows rightShadows'>&nbsp;</div><div class='rShadow rightShadows'>&nbsp;</div>" +
                                  "<div class='trShadow rightShadows'>&nbsp;</div></div>" +
                                  "<div class='tooltip topDiv' id='" + options.tooltipId + "'>" + content + "</div>"

                    //$("body").append("<div class='tooltip' id='" + options.tooltipId + "'><div>" + content + "</div></div>");
                    $("body").append(popupWithShadow);

                    var xLeft = (e.pageX + options.xOffset) + "px";
                    var xTop = (e.pageY - options.yOffset) + "px";
                    var ttip = $("#" + options.tooltipId);

                    ttip
            .css("position", "absolute")
            .css("top", xTop)
            .css("left", xLeft)
            .css("zIndex", "10000000");
                    ttip.find('div').fadeIn("slow");
                    setShadow(ttip, xTop, xLeft);
                }
            },

			function() {
			    $("#" + options.tooltipId).remove();
			    $("#shadowContainer").remove();
			    //$(this).attr("title", title);
			});

            function setShadow(popUp, xTop, xLeft) {
                var xWidth = popUp.outerWidth();
                var xHeight = popUp.outerHeight();
                if (xWidth != null) {
                    $("#shadowContainer")
            .css("position", "absolute")
            .css("top", xTop)
            .css("left", xLeft)
            .css("width", xWidth)
            .css("height", xHeight);

                    var btmShad = xHeight.toString() + "px";
                    var bShad = (parseInt(xWidth) - 15).toString() + "px";

                    $(".bottomShadows").css("top", btmShad);
                    $(".bShadow").css("width", bShad);
                    var h = xHeight - 15;
                    if (h < 0) { h = 0; }
                    $(".rShadow").css("height", h + "px");
                }
            }


            $(this).mousemove(function(e) {
                if ($("#shadowContainer").html() != null) {
                    var xLeft = (e.pageX + options.xOffset) + "px";
                    var xTop = (e.pageY - options.yOffset) + "px";
                    var ttip = $("#" + options.tooltipId);
                    ttip
					  .css("top", xTop)
					  .css("left", xLeft);
                    setShadow(ttip, xTop, xLeft);
                }
            });

            if (options.clickRemove) {
                $(this).mousedown(function(e) {
                    $("#" + options.tooltipId).remove();
                    $("#shadowContainer").remove();
                    //$(this).attr("title", title);
                });
            }
        });




    };

})(jQuery);


